import { ImagePlus } from "lucide-react";

/**
 * PhotoSlot — reusable placeholder frame for large section images.
 *
 * Use for anywhere in the site that will eventually host a photograph the
 * client provides (facility shots, tea plantations, hero imagery, etc.).
 * Matches the branded diagonal-line placeholder used inside ProductCard.
 */
export const PhotoSlot = ({
  label = "Photo slot",
  caption,
  height = "h-80",
  shape = "rect", // "rect" | "arch"
  tone = "cream", // "cream" | "dark"
  className = "",
  testId,
}) => {
  const isDark = tone === "dark";
  const shapeCls =
    shape === "arch" ? "arch-frame" : "rounded-2xl";
  const surface = isDark
    ? "border border-[#F0E6C0]/25 bg-[#4A3120]"
    : "border border-[#3D2817] bg-[#EFE4B8]";
  const iconColor = isDark ? "text-[#E0A96D]" : "text-[#7A4E24]";
  const titleColor = isDark ? "text-[#F0E6C0]" : "text-[#3D2817]";
  const labelColor = isDark ? "text-[#D8B98A]" : "text-[#7A4E24]";
  const bgPattern = isDark
    ? "repeating-linear-gradient(45deg, transparent 0 16px, rgba(240,230,192,0.09) 16px 17px)"
    : "repeating-linear-gradient(45deg, transparent 0 16px, rgba(61,40,23,0.09) 16px 17px)";

  return (
    <div
      data-testid={testId}
      className={`relative overflow-hidden ${shapeCls} ${surface} ${height} w-full flex items-center justify-center ${className}`}
    >
      <div
        aria-hidden="true"
        className="absolute inset-0 opacity-30"
        style={{ backgroundImage: bgPattern }}
      />
      <div className="relative flex flex-col items-center gap-3 text-center px-6">
        <ImagePlus size={36} strokeWidth={1.2} className={iconColor} />
        {caption && (
          <p className={`font-display text-2xl md:text-3xl italic ${titleColor}`}>
            {caption}
          </p>
        )}
        <p className={`text-[10px] uppercase tracking-[0.25em] ${labelColor}`}>
          {label}
        </p>
      </div>
    </div>
  );
};
